<template>
  <div>
    <BaseLoading v-if="isScoreCountsLoading" />
    <template v-else>
      <BaseAlert v-if="!scoreCounts">
        {{ $t('there-is-no-current-standings-stats-for-this-round') }}
      </BaseAlert>
      <template v-else>
        <ThePlayersStandingRow
          v-for="position in scoreCounts"
          :key="position.position"
          :users="getScorePlayers({ roundId: match.round_id, score: position.score })"
          :users-count="position.numOfPlayers"
          :is-users-loading="position.numOfPlayers ? isScorePlayersLoading(position.score) : false"
          :rank="position.position"
          :score="position.score"
          :is-my-position="position.isMyPosition || false"
          @onSetCurrentScore="handleSetCurrentScore"
        />

        <TheRankOverviewModal
          v-if="currentScore"
          :current-position="currentPosition"
          :current-score="currentScore"
          @close="handleRankDetailClose"
        />
      </template>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import BaseLoading from '@/components/Atoms/BaseLoading'
import ThePlayersStandingRow from '@/components/Molecules/ThePlayersStandingRow'
import TheRankOverviewModal from '@/components/Molecules/TheRankOverviewModal'
import BaseAlert from '@/components/Atoms/BaseAlert'

export default {
  components: {
    BaseAlert,
    TheRankOverviewModal,
    BaseLoading,
    ThePlayersStandingRow,
  },
  data() {
    return {
      matchId: `${this.$route.params.league}/${this.$route.params.match}`,
      currentScore: null,
    }
  },
  computed: {
    ...mapState({
      isScoreCountsLoading: state => state['rounds/scoreCounts'].isScoreCountsLoading,
      scorePlayers: state => state['rounds/scoreCounts'].scorePlayers,
    }),
    ...mapGetters({
      getScorePlayers: 'rounds/scoreCounts/getScorePlayers',
      isScorePlayersLoading: 'rounds/scoreCounts/isScorePlayersLoading',
    }),
    match() {
      return this.$store.getters['matches/stats/getMatchStats'](this.matchId)
    },
    scoreCounts() {
      return this.$store.getters['rounds/scoreCounts/getScoreCountsByRoundId']({
        roundId: this.match.round_id,
      })
    },
    currentPosition() {
      return {
        users: this.getScorePlayers({
          roundId: this.match.round_id,
          score: this.currentScore,
        }),
      }
    },
  },
  methods: {
    handleRankDetailClose() {
      this.currentScore = null
    },
    handleSetCurrentScore({ score }) {
      this.currentScore = score
    },
  },
}
</script>
